import axios from "axios";
import React, { useContext, useState } from "react";
import "react-toastify/dist/ReactToastify.css";
const AppContext = React.createContext();

const AppProvider = ({ children }) => {
  // const baseUrl = "http://localhost:5000/api/";
  const baseUrl =
    process.env.REACT_APP_API_URL ||
    "https://profitmonitoringapi.vercel.app/api/";
  const user = JSON.parse(sessionStorage.getItem("user"));
  const _id = user?._id;
  const [depositHistory, setDepositHistory] = useState([]);
  const [withdrawHistory, setWithdrawHistory] = useState([]);
  const [userDetails, setUserDetails] = useState([]);
  const [userCards, setUserCards] = useState([]);
  const [userLoading, setUserLoading] = useState(false);
  const [userError, setUserError] = useState("");
  const [cardLoading, setCardLoading] = useState(false);
  const [cardError, setCardError] = useState("");
  const [btcLoading, setBtcLoading] = useState(false);
  const [widget, setWidget] = useState(false);

  const getUser = (token, id) => {
    setUserLoading(true);
    setUserError("");
    return axios
      .get(`${baseUrl}users/${id || user?._id}`, {
        headers: { token },
      })
      .then((response) => {
        if (response.status !== 200) throw new Error("Profile request failed.");
        setUserDetails(response.data);
        sessionStorage.setItem("user", JSON.stringify(response.data));
        return response.data;
      })
      .catch((error) => {
        setUserError(error?.response?.data?.message || "We couldn't load your account details.");
        return null;
      })
      .finally(() => setUserLoading(false));
  };

  const getAllCard = (token) => {
    setCardLoading(true);
    setCardError("");
    return axios
      .get(`${baseUrl}card/${_id}`, { headers: { token } })
      .then((response) => {
        const cards = Array.isArray(response.data?.cards) ? response.data.cards : [];
        setUserCards(cards);
        return cards;
      })
      .catch((error) => {
        setCardError(error?.response?.data?.message || "We couldn't retrieve your card status.");
        setUserCards([]);
        return [];
      })
      .finally(() => setCardLoading(false));
  };

  const getAllDeposits = (accessToken) => {
    axios
      .get(`${baseUrl}deposit/${_id}`, {
        headers: { token: accessToken },
      })
      .then((data) => {
        setDepositHistory(data.data.deposit);
        sessionStorage.setItem(
          "deposits",
          JSON.stringify(
            data.data.deposit
              .filter(
                (deposits) =>
                  deposits.status === "true" || deposits.status === "approved"
              )
              .reduce((accumulator, { amount }) => accumulator + amount / 1, 0)
          )
        );
      })
      .catch((error) => {});
  };
  const getAllWithdrawals = (accessToken) => {
    axios
      .get(`${baseUrl}transfer/${_id}`, {
        headers: { token: accessToken },
      })
      .then((data) => {
        setWithdrawHistory(data.data.transfers);
        sessionStorage.setItem(
          "withdraw",
          JSON.stringify(data.data.totalAmountTransferred)
        );
      })
      .catch((error) => {});
  };

  const getPendingDepositsAmount = () => {
    return depositHistory
      .filter(
        (deposit) => deposit.status === "false" || deposit.status === "pending"
      )
      .reduce((accumulator, { amount }) => accumulator + amount / 1, 0);
  };
  const getFailedDepositsAmount = () => {
    return depositHistory
      .filter((deposit) => deposit.status === "failed")
      .reduce((accumulator, { amount }) => accumulator + amount / 1, 0);
  };
  const getPendingWithdrawalsAmount = () => {
    return withdrawHistory
      .filter(
        (withdraw) =>
          withdraw.status === "false" || withdraw.status === "pending"
      )
      .reduce((accumulator, { amount }) => accumulator + amount / 1, 0);
  };
  const getFailedWithdrawalsAmount = () => {
    return withdrawHistory
      .filter((withdraw) => withdraw.status === "failed")
      .reduce((accumulator, { amount }) => accumulator + amount / 1, 0);
  };
  const getSuccessfulWithdrawalsAmount = () => {
    return withdrawHistory
      .filter(
        (withdraw) =>
          withdraw.status === "true" || withdraw.status === "approved"
      )
      .reduce((accumulator, { amount }) => accumulator + amount / 1, 0);
  };

  return (
    <AppContext.Provider
      value={{
        baseUrl,
        setUserDetails,
        userDetails,
        getUser,
        userLoading,
        userError,
        getAllDeposits,
        btcLoading,
        setBtcLoading,
        depositHistory,
        getPendingDepositsAmount,
        getAllWithdrawals,
        withdrawHistory,
        getFailedWithdrawalsAmount,
        getPendingWithdrawalsAmount,
        getSuccessfulWithdrawalsAmount,
        getFailedDepositsAmount,
        widget,
        setWidget,
        userCards,
        getAllCard,
        cardLoading,
        cardError,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

const useGlobalContext = () => {
  return useContext(AppContext);
};

export { useGlobalContext, AppProvider };
